import APIClient from '@/shared/http/clients/api'

const resourceName = 'APRTemplateRiscoCausaConsequenciaFonteMedidas'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetCausas = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetCausas`, data, config)
const GetFonte = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetFonte`, data, config)
const GetConsequencia = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetConsequencia`, data, config)
const GetMedidaControle = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetMedidaControle`, data, config)

const aprTemplateRiskCauseConsequenceSourceMeasuresRepository = {
  GetCausas,
  GetFonte,
  GetConsequencia,
  GetMedidaControle
}

export default aprTemplateRiskCauseConsequenceSourceMeasuresRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprTemplateRiskCauseConsequenceSourceMeasures.js